/**
 * Generic list-items builder
 * Shared by useFriendData and useGroupsData to avoid duplicated categorize + duplicate logic
 */

export interface BuildListItemsConfig<T, R> {
  items: T[]
  getCategory: (item: T) => string
  categoryOrder: string[]
  duplicateCount: number
  getStableId: (item: T) => string
  toListItem: (
    item: T,
    type: string,
    listItemId: string,
    entityId: string,
    dupIndex?: number,
    dupSubIndex?: number
  ) => R
}

/**
 * Build a unified list of items from a source list: categorize, optionally duplicate, map to list items
 */
export function buildListItems<T, R>(config: BuildListItemsConfig<T, R>): R[] {
  const { items, getCategory, categoryOrder, duplicateCount, getStableId, toListItem } = config
  const buckets = new Map<string, T[]>()
  for (const item of items) {
    const cat = getCategory(item)
    if (!buckets.has(cat)) buckets.set(cat, [])
    buckets.get(cat)!.push(item)
  }
  const result: R[] = []
  for (const type of categoryOrder) {
    const list = buckets.get(type) ?? []
    list.forEach((item, index) => {
      if (duplicateCount > 1) {
        for (let i = 0; i < duplicateCount; i++) {
          const listItemId = `${getStableId(item)}-${type}-dup-${index}-${i}`
          const entityId = `${getStableId(item)}-dup-${index}-${i}`
          result.push(toListItem(item, type, listItemId, entityId, index, i))
        }
      } else {
        result.push(toListItem(item, type, `${getStableId(item)}-${type}`, getStableId(item)))
      }
    })
  }
  return result
}
